let ctmqtyValue = 1;
// jQuery(document).ready(function () {
//   $('.product-form__input input[name="quantity"]').change(function () {
//     var qty = $(this).closest('product-info').find('.product-form__input input[name="quantity"]:checked').val();
//     var addon_single_price = $('.pair_it_section .price-item.price-item--regular').attr('data-single-price');
//      var addon_pair_price = $('.pair_it_section .price-item.price-item--regular').attr('data-pair-price');
//     if (qty == 1) {
//       var price = $(this).closest('product-info').find('variant-radios-custom input[name="Size"]:checked').data('price');
//       var priceCompare = $(this).closest('product-info').find('variant-radios-custom input[name="Size"]:checked').data('compare-at-price');
//      $('.addon_qyt_main .addon_qyt').text('Single');
//       $('.addon_qyt_main .addon_qyt').attr('data-qyt', 1)
//       $('.pair_it_section .price-item.price-item--regular').text(addon_single_price);
//       ctmqtyValue = qty;
//     } else {
//       var price = $(this).closest('product-info').find('variant-radios-custom input[name="Size"]:checked').data('price-pair');
//       var priceCompare = $(this).closest('product-info').find('variant-radios-custom input[name="Size"]:checked').data('compare-at-price-pair');
//       $('.addon_qyt_main .addon_qyt').text('Pair');
//        $('.addon_qyt_main .addon_qyt').attr('data-qyt', 2)
//        $('.pair_it_section .price-item.price-item--regular').text(addon_pair_price);
//       ctmqtyValue = qty;
//     }

//     if (priceCompare != 0) {
//       $(this).closest('product-info').find('.product__info-wrapper .mn_price .price__sale .price-item--sale').text(price);
//       $(this).closest('product-info').find('.product__info-wrapper .mn_price .price__sale .price-item--regular').text(priceCompare);
//     } else {
//       $(this).closest('product-info').find('.product__info-wrapper .mn_price .price__regular .price-item--regular').text(price);
//     }


//       var priceItemRegular =  $('.product__info-wrapper .mn_price .price-item').attr('data-price') / 100;
//   var add_single_price = $('.pair_it_section .price-item.price-item--regular').attr('data-sl-price');
//   var add_single_pricex2 = add_single_price * 2;
//   var priceItemRegularx2 = priceItemRegular * 2;
//   var addon_regular_price = parseFloat(priceItemRegular) + parseInt(add_single_price);
//   var addon_regular_pricex2 = parseFloat(add_single_pricex2) + parseInt(priceItemRegularx2);

//   var currencySymbol = document.querySelector('#HeaderCountryForm .localization-selector').dataset.currencySymbol;
//   var currencyCode = document.querySelector('#HeaderCountryForm .localization-selector').dataset.currencyCode;

//         var isoLanguageCode = 'en-AU';
//         switch (currencyCode) {
//           case 'EUR':
//             isoLanguageCode = 'en-US';
//             break;
//           case 'VND':
//             isoLanguageCode = 'vi-VN';
//             break;
//           case 'CAD':
//             isoLanguageCode = 'en-CA';
//             break;
//           case 'CNY':
//             isoLanguageCode = 'zh-CN';
//             break;
//           case 'DKK':
//             isoLanguageCode = 'da-DK';
//             break;
//           case 'FJD':
//             currencyCode = 'AUD';
//             break;
//           case 'HKD':
//             currencyCode = 'AUD';
//             break;
//           case 'HUF':
//             isoLanguageCode = 'hu-US';
//             break;
//           case 'IDR':
//             isoLanguageCode = 'id-US';
//             break;
//           case 'JPY':
//             isoLanguageCode = 'ja-JP';
//             break;
//           case 'MYR':
//             isoLanguageCode = 'ms-MY';
//             break;
//           case 'PHP':
//             isoLanguageCode = 'fil-PH';
//             break;
//           case 'SGD':
//             isoLanguageCode = 'en-SG';
//             break;
//           case 'KRW':
//             isoLanguageCode = 'ko-KR';
//             break;
//           case 'SEK':
//             isoLanguageCode = 'sv-SE';
//             break;
//           case 'THB':
//             isoLanguageCode = 'th-TH';
//             break;
//           case 'GBP':
//             isoLanguageCode = 'en-UK';
//             break;
//         }

//         var formatter = new Intl.NumberFormat(isoLanguageCode, {
//           style: 'currency',
//           currency: currencyCode,
//         });
//        var checkaddonSElect = $('.variant-wrapper.addon .select__select').val();
//             if (checkaddonSElect) {
//                 if (ctmqtyValue == 1) {
//                    var addon_regular_price = formatter.format(addon_regular_price);
//                   $('.product__info-wrapper .mn_price .price-item.price-item--regular').text(addon_regular_price);
//                 }
//                 if (ctmqtyValue == 2) {
//                    var addon_regular_pricex2 = formatter.format(addon_regular_pricex2);
//                     $('.product__info-wrapper .mn_price .price-item.price-item--regular').text(addon_regular_pricex2);
//                 }
//           }
    
//   });
// });

//const existingElement = customElements.get('variant-radios');
class VariantRadiosCustom extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        var price = document.getElementById(`price-${this.dataset.section}`);
        var priceItemRegular = parseFloat(destination.querySelector('.product__info-wrapper .mn_price .price__regular .price-item--regular').dataset.price) / 100;
        var add_single_price = $('.pair_it_section .price-item.price-item--regular').attr('data-sl-price');
        var addon_regular_price = parseFloat(priceItemRegular) + parseInt(add_single_price);
        var add_single_pricex2 = add_single_price * 2;
        var priceItemRegularx2 = priceItemRegular * 2;
         var addon_regular_pricex2 = parseFloat(add_single_pricex2) + parseInt(priceItemRegularx2);
        var priceItemCompare = parseFloat(destination.querySelector('.product__info-wrapper .mn_price .price__sale .price-item--regular').dataset.compareAtPrice) / 100;
        var priceItemComparex2 = priceItemCompare * 2;

        var qtyBox = document.getElementById(`qty-box-${this.dataset.section}`);
        var radiosInput = qtyBox.querySelectorAll('input[type=radio]');
        var qtyValue = qtyBox.querySelector('input[type=radio]:checked').value;
        var currencySymbol = document.querySelector('#HeaderCountryForm .localization-selector').dataset.currencySymbol;
        var currencyCode = document.querySelector('#HeaderCountryForm .localization-selector').dataset.currencyCode;

        var isoLanguageCode = 'en-AU';
        switch (currencyCode) {
          case 'EUR':
            isoLanguageCode = 'en-US';
            break;
          case 'VND':
            isoLanguageCode = 'vi-VN';
            break;
          case 'CAD':
            isoLanguageCode = 'en-CA';
            break;
          case 'CNY':
            isoLanguageCode = 'zh-CN';
            break;
          case 'DKK':
            isoLanguageCode = 'da-DK';
            break;
          case 'FJD':
            currencyCode = 'AUD';
            break;
          case 'HKD':
            currencyCode = 'AUD';
            break;
          case 'HUF':
            isoLanguageCode = 'hu-US';
            break;
          case 'IDR':
            isoLanguageCode = 'id-US';
            break;
          case 'JPY':
            isoLanguageCode = 'ja-JP';
            break;
          case 'MYR':
            isoLanguageCode = 'ms-MY';
            break;
          case 'PHP':
            isoLanguageCode = 'fil-PH';
            break;
          case 'SGD':
            isoLanguageCode = 'en-SG';
            break;
          case 'KRW':
            isoLanguageCode = 'ko-KR';
            break;
          case 'SEK':
            isoLanguageCode = 'sv-SE';
            break;
          case 'THB':
            isoLanguageCode = 'th-TH';
            break;
          case 'GBP':
            isoLanguageCode = 'en-UK';
            break;
        }

        var formatter = new Intl.NumberFormat(isoLanguageCode, {
          style: 'currency',
          currency: currencyCode,
        });
        
        if (price) {
           var checkaddonSElect = $('.variant-wrapper.addon .select__select').val();
          price.classList.remove("visibility-hidden");
          var addon_regular_price = formatter.format(addon_regular_price);
         
          if (qtyValue == 1) {
          if (checkaddonSElect) {
            $('.product__info-wrapper .mn_price .price-item.price-item--regular').text(addon_regular_price);
          }
          }
          
          if (qtyValue == 2) {
            var priceText = formatter.format(priceItemRegularx2);
            var addon_regular_pricex2 = formatter.format(addon_regular_pricex2);
             if (checkaddonSElect) {
                $('.product__info-wrapper .mn_price .price-item.price-item--regular').text(addon_regular_pricex2);
             }
            if (currencyCode == 'HUF') {
              var formattedNumber = priceItemRegularx2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              priceText = `${formattedNumber} Ft`;
            }
            if (currencyCode == 'AED') {
              var priceText = "Dhs. " + priceItemRegularx2.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            //Change price text
            price.querySelector('.product__info-wrapper .mn_price .price__regular .price-item--regular').textContent = priceText;
            if (priceItemCompare) {
              var priceCompareText = formatter.format(priceItemComparex2);
              if (currencyCode == 'HUF') {
                var formattedNumber = priceItemComparex2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                priceCompareText = `${formattedNumber} Ft`;
              }
              if (currencyCode == 'AED') {
                var priceCompareText = "Dhs. " + priceItemComparex2.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              }
              //Change price text
              price.querySelector('.price__sale .price-item--regular').textContent = priceCompareText;
              price.querySelector('.price__sale .price-item--sale').textContent = priceText;
            }
          }
        }

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }
}

customElements.define('variant-radios-custom', VariantRadiosCustom);